import {useMemo} from 'react';
import {useVodTracking} from './useVodTracking';
import {useVodItemData} from './useVodItemData';

// Hooks externes
import {useTranslation} from 'gatsby-plugin-react-i18next';
import useBreakpoint from 'design-system/src/WebComponent/Grid/hooks/useBreakpoint';

// Hooks métier
import {useVodNavigation} from './useVodNavigation';
import {useVodBookmark} from './useVodBookmark';
import {useVodShare} from './useVodShare';
import {useVodTrailer} from './useVodTrailer';
import {useVodCasting} from './useVodCasting';

// Types
import {
  PaywallSectionTrackingProps,
  PaywallSourceType,
} from '@src/Services/Amplitude/hooks/tracker';

export function useVodSinglePageLogic() {
  const {t} = useTranslation('translation');
  const {isMobile} = useBreakpoint();
  const {navigation, onWatchClick} = useVodNavigation();
  const {vodItem, listCategory, loading} = useVodItemData();
  function calculateWidth() {
    return window.innerWidth * (isMobile ? 1 : 0.8);
  }
  const {bookmarkItem, handleFav} = useVodBookmark(vodItem);
  const {
    handleShare,
    isOpenDialogShare,
    setIsOpenDialogShare,
    linkToShare,
    setLinkToShare,
  } = useVodShare(vodItem);
  const {openTrailer} = useVodTrailer();

  const trackingData: PaywallSectionTrackingProps = useMemo(() => {
    const {id, title} = vodItem || {};
    return {
      source_type: PaywallSourceType.VodSinglePagePaywallChecker,
      content_id: id || '',
      source_name: title || 'vod-single-item-page',
      source_url: location.href,
    };
  }, [vodItem]);

  useVodCasting(vodItem);

  useVodTracking(vodItem);

  return {
    vodItem,
    listCategory,
    bookmarkItem,
    loading,
    isMobile,
    calculateWidth,
    t,
    onWatchClick,
    openTrailer,
    handleFav,
    handleShare,
    isOpenDialogShare,
    setIsOpenDialogShare,
    linkToShare,
    setLinkToShare,
    trackingData,
    navigation,
  };
}
